import { CartesianGrid, Legend, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { mockTitle } from "@/data/mocks";
import { PASS_SCORE } from "@/lib/scoring";

const LINES = [["overall", "#4f46e5", 3], ["listening", "#0ea5e9", 1.5], ["reading", "#10b981", 1.5], ["speaking", "#f59e0b", 1.5], ["writing", "#ec4899", 1.5]];

export const ScoreTrend = ({ hist }) => {
  const data = [...hist].reverse().map((h, i) => ({ name: `#${i + 1}`, date: new Date(h.date).toLocaleDateString(), title: mockTitle(h), overall: h.overall, ...h.skills }));
  return (
    <div data-testid="score-trend-chart" className="rounded-xl bg-white p-6 shadow-xl shadow-slate-950/30">
      <h3 className="font-display text-xl font-bold text-slate-900">Score Trend</h3>
      <p className="text-sm text-slate-500">Overall and skill scores across your mocks. Dashed line marks the 61 pass mark.</p>
      {data.length < 2 && <p data-testid="score-trend-hint" className="mt-1 text-xs text-amber-600">Take one more mock to see a trend line.</p>}
      <div className="mt-4 h-72">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 16, left: -16, bottom: 0 }}>
            <CartesianGrid stroke="#e2e8f0" strokeDasharray="3 3" />
            <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748b" }} />
            <YAxis domain={[20, 80]} tick={{ fontSize: 11, fill: "#64748b" }} />
            <Tooltip labelFormatter={(l, p) => (p?.[0] ? `${p[0].payload.title} · ${p[0].payload.date}` : l)} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <ReferenceLine y={PASS_SCORE} stroke="#ef4444" strokeDasharray="6 4" label={{ value: `Pass ${PASS_SCORE}`, fill: "#ef4444", fontSize: 11, position: "insideTopRight" }} />
            {LINES.map(([k, c, w]) => <Line key={k} type="monotone" dataKey={k} stroke={c} strokeWidth={w} dot={{ r: 3 }} name={k.charAt(0).toUpperCase() + k.slice(1)} />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
